<template>
	<div>
		<div>
			<h2>日志</h2>
			<el-button type="success" @click="toInfo" style="float: right; margin-right: 10%;">录入信息</el-button>
		</div>
		<el-header>
			<el-form :inline="true">
				<el-form-item label="登记号">
					<el-input v-model="PapmiNo" />
				</el-form-item>
				<el-form-item label="姓名">
					<el-input v-model="PapmiName" />
				</el-form-item>
				<el-form-item label="时间段">
					<el-date-picker 
					type="daterange" 
					range-separator="到"
					start-placeholder="开始时间" 
					end-placeholder="结束时间" 
					value-format="yyyy-MM-dd"
					v-model="selectDate" 
					 />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="loadTodayTable(false)">查询</el-button>
					<el-button type="primary" @click="clearQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</el-header>
		<el-main>
			<el-table :data="tableData">
				<el-table-column align="center" prop="PapmiNo" label="登记号"></el-table-column>
				<el-table-column align="center" prop="PapmiName" label="姓名"></el-table-column>
				<el-table-column align="center" prop="PapmiSex" label="性别">
					<template v-slot="scope">{{ scope.row.PapmiSex === '1' ? '男' : '女' }}</template>
				</el-table-column>
				<el-table-column align="center" prop="PapmiAge" label="年龄"></el-table-column>
				<el-table-column align="center" prop="PapmiTelH" label="手机号码"></el-table-column>
				<el-table-column align="center" prop="PapmiDob" label="出生日期"></el-table-column>
				<el-table-column align="center" prop="DSBHYY" label="右眼度数变化"></el-table-column>
				<el-table-column align="center" prop="DSBH" label="左眼度数变化"></el-table-column>
				<el-table-column align="center" prop="TjDate" label="就诊日期"></el-table-column>
				<el-table-column align="center" prop="TjTime" label="就诊时间"></el-table-column>
				<el-table-column align="center" label="操作">
					<template v-slot="scope">
						<el-button @click="showInfo(scope.row)" type="primary">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-main>
		<el-dialog :visible.sync="showPopup" title="详情" width="30%" :show-close='false'>
			<InfoPopup :pInfo="pInfo"></InfoPopup>
			<template #footer>
				<span class="dialog-footer">
					<el-button type="primary" @click="showPopup = false">确定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	import InfoPopup from './InfoPopup.vue';

	export default {
		components: {
			InfoPopup
		},
		data() {
			return {
				tableData: [],
				PapmiNo: '',
				PapmiName: '',
				SDate: '',
				EDate: '',
				selectDate: '',
				dialogVisible: false,
				dialogMessage: '',
				showPopup: false,
				pInfo: {},
			}
		},
		mounted() {
			this.tableData = [];
			this.loadTodayTable(true);
		},
		methods: {
			showInfo(info) {
				console.log("详情");
				this.showPopup = true;
				console.log('info', info);
				this.pInfo = JSON.parse(JSON.stringify(info));
			},
			toInfo() {
				this.$router.push("/info");
			},
			getDate() {
				const nowDate = new Date();
				const date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate(),
				};
				const newmonth = date.month >= 10 ? date.month : "0" + date.month;
				const day = date.date >= 10 ? date.date : "0" + date.date;
				return date.year + "-" + newmonth + "-" + day;
			},
			async loadTodayTable(val) {
				this.SDate = '';
				this.EDate = '';
				this.tableData = [];
				// 时间
				if (this.selectDate.length > 0) {
					if (this.selectDate.length === 1) {
						this.EDate = this.selectDate[0];
					} else {
						this.EDate = this.selectDate[1];
					}
					this.SDate = this.selectDate[0];
				} else {
					val = true;
				}
				// 登记号
				if (this.PapmiNo.length > 10) {
					this.dialogVisible = true;
					this.dialogMessage = "登记号过长-请您检查登记号格式！";
					return;
				} else if (this.PapmiNo && this.PapmiNo.length < 10) {
					this.PapmiNo = this.PapmiNo.padStart(10, '0');
					val = true;
				}
				// 病人姓名
				if (this.PapmiName) {
					val = true;
				}
				if (val && !this.SDate && !this.EDate) {
					var nowDay = this.getDate();
					this.SDate = nowDay;
					this.EDate = nowDay;
				}
				const soapRequest = `
				        <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org">
				           <soapenv:Header/>
				           <soapenv:Body>
				              <tem:FindPapmi>
				                 <tem:Input>{"SDate":"` + this.SDate + `","EDate":"` + this.EDate + `","PapmiName":"` + this.PapmiName + `","PapmiNo":"` + this.PapmiNo + `"}</tem:Input>
				              </tem:FindPapmi>
				           </soapenv:Body>
				        </soapenv:Envelope>
				      `;
				const config = {
					headers: {
						'Content-Type': 'text/xml;charset=UTF-8',
						'SOAPAction': 'http://tempuri.org/YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.FindPapmi',
						'X-Requested-With': 'XMLHttpRequest',
						'Cache-Control': 'no-cache'
					},
				};
				console.log("入参：", soapRequest);
				const response = await axios.post('/api/csp/i-MEDI//YKYY.WFJTT.JG.GetPapmi.BS.GetPapmi.cls',soapRequest, config);
				if (response.status === 200) {
					let soapData = this.x2js.xml2js(response.data);
					console.log("返回值：", soapData);
					let result = soapData.Envelope.Body.FindPapmiResponse.FindPapmiResult;
					// 返回值为空
					if (result === '8@%Library.GlobalCharacterStream') {
						return;
					}
					let jsonObj = JSON.parse(result);
					if (jsonObj) {
						let jsonObj = JSON.parse(result);
						if (jsonObj.FindMsg) {
							this.tableData = jsonObj.FindMsg;
							// console.log("返回tableData：" + JSON.stringify(this.tableData));
						} else {
							return;
							console.log("Error：" + jsonObj.ResultMsg)
						}
					}

				}
			},
			clearQuery() {
				this.PapmiNo = '';
				this.PapmiName = '';
				this.selectDate = '';
				this.SDate = '';
				this.EDate = '';
				this.loadTodayTable();
			}
		}
	}
</script>

<style>
</style>